(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-details-template"]) return;
  try {
    
  class StickyATC extends HTMLElement {
    constructor() {
      super();

      var self = this;
      var productAvailable = false;
      var productATC = document.querySelector('.product_section .purchase-details__buttons');
      if(productATC && !productATC.getAttribute('disabled')){
        productAvailable = true;
      }

      if(productAvailable){
        this.visible();

        if(document.documentElement.clientWidth > 798){
          this.querySelector(`.sticky_atc__variants input[name="id"]`).setAttribute('name', 'OldId');
          this.querySelector('.sticky_atc__variants select').setAttribute('name', 'id');         
        } else {
          this.querySelector(`.sticky_atc__variants input[name="oldId"]`).setAttribute('name', 'id');
          this.querySelector('.sticky_atc__variants select').setAttribute('name', 'oldId');
        }

        window.addEventListener('scroll',
          throttle(function(){
            self.visible()
          }, 200)
        );

        window.addEventListener('resize',
          throttle(function(){
            self.visible()
          }, 200)
        );

        document.addEventListener('shopify:section:load', function(e){
          self.visible()
        });
      }

      this.productVariants = this.querySelector('.sticky_atc__variants');
      if(this.productVariants){
        this.changeVariants();
      }
    }

    changeVariants (){
      var self = this;
        document.querySelectorAll('.swatch_options input[name^=option]').forEach((input) => {
          input.addEventListener('change', () => {
            var option = self.querySelector(`.sticky_atc__variants select option[value="${input.nextElementSibling.dataset.id}"]`)
            if(document.documentElement.clientWidth > 798){
              self.querySelector(`.sticky_atc__variants input[name="id"]`).setAttribute('name', 'oldId');
              self.querySelector('.sticky_atc__variants select').setAttribute('name', 'id');
              option.selected = true;              
            } else {
              self.querySelector('.sticky_atc__variants select').setAttribute('name', 'oldId');
              self.querySelector(`.sticky_atc__variants input[name="oldId"]`).setAttribute('name', 'id');
              self.querySelector(`.sticky_atc__variants input[name="id"]`).value = input.nextElementSibling.dataset.id;
            }
          })
        })
    }

    visible() {
      var button_ATC = document.querySelector('.product_section .purchase-details__buttons');
      var footer = document.querySelector('footer');
      var scroll = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      if(button_ATC && ((!this.classList.contains('medium-down--hide') && document.documentElement.clientWidth > 798) || (!this.classList.contains('small--hide') && document.documentElement.clientWidth <= 797))){
        if(isInViewport(button_ATC) || scroll < (offset(button_ATC).top + button_ATC.getBoundingClientRect().height) || scroll == 0 ){
          if(this.classList.contains('active')) {
            this.classList.remove('active'), footer.style.marginBottom = '';
          }
        } else {
          if(!this.classList.contains('active')) {
            this.classList.add('active'),
            footer.style.marginBottom = this.getBoundingClientRect().height + 'px';
          }
        }
      }
    }
  }
  customElements.define('sticky-atc', StickyATC);

  function isInViewport(elem) {
    let x = elem.getBoundingClientRect().left;
    let y = elem.getBoundingClientRect().top;
    let ww = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    let hw = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    let w = elem.clientWidth;
    let h = elem.clientHeight;
    return (
        (y < hw &&
          y + h > 0) &&
        (x < ww &&
          x + w > 0)
    );
  }

  function offset(el){
    var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return {
      top: rect.top + scrollTop,
      left: rect.left + scrollLeft
    }
  }

  function throttle(callback, wait) {
    var time = Date.now();
    return function() {
      if ((time + wait - Date.now()) < 0) {
        callback();
        time = Date.now();
      }
    }
  }

  } catch(e) { console.error(e); }
})();
})();
